import React, { FC } from "react";

import { MyRoutes } from "~/config/Paths";

import { EmployeeConditionSurveyType } from "~/domains";

import { CatchTitleBorder, LinkTitleItem } from "~/ui";
import { InfiniteScrollWithMoreButton } from "~/ui";

type PropsType = {
  title: string;
  employeeConditionSurveys: EmployeeConditionSurveyType[];
  fetchNextPage: () => void;
  hasMore?: boolean;
  className?: string;
  businessSectionId?: string;
};

export const EmployeeConditionSurveyTitleInfinitiesScroll: FC<PropsType> = ({
  title,
  employeeConditionSurveys,
  hasMore,
  className = "",
  businessSectionId = "",
  fetchNextPage,
}: PropsType) => {
  return (
    <div className={className}>
      <CatchTitleBorder text={title} />
      <InfiniteScrollWithMoreButton
        itemsLength={employeeConditionSurveys.length}
        nextFetchFunction={fetchNextPage}
        hasMore={hasMore}
        className="mt-6"
        scrollClassName="space-y-6"
      >
        {employeeConditionSurveys.map((item) => (
          <LinkTitleItem
            key={item.id}
            to={MyRoutes.Members.inputEmployeeConditionSurveysShow({
              id: item.id,
              q: { business_section_id: businessSectionId },
            })}
            title={item.title}
          />
        ))}
      </InfiniteScrollWithMoreButton>
    </div>
  );
};
